// Classification step constants

// Brand type definition
export interface Brand {
  id: string;
  name: string;
}

// Available brands matching HTML design
export const AVAILABLE_BRANDS: Brand[] = [
  { id: "nike", name: "Nike" },
  { id: "adidas", name: "Adidas" },
  { id: "unilever", name: "Unilever" },
  { id: "puma", name: "Puma" },
  { id: "samsung", name: "Samsung" },
  { id: "apple", name: "Apple" },
  { id: "sony", name: "Sony" },
  { id: "lg", name: "LG" },
  { id: "panasonic", name: "Panasonic" },
  { id: "nestle", name: "Nestlé" },
  { id: "cocacola", name: "Coca-Cola" },
  { id: "pepsi", name: "Pepsi" },
  { id: "other", name: "Other" },
];
